<template>
    <van-popup v-model="show" mode="center" @click-overlay="close">
        <div class="content">
            <div class="item-balance">
                <div>{{ $t('BalancePopup.GameBalance') }}</div>
                <div class="item-balance-val1">{{ formatCurrency(gameBalance, 2) }}</div>
            </div>
            <div class="item-balance">
                <div>{{ $t('BalancePopup.BonusBalance') }}</div>
                <div class="item-balance-val3">{{ formatCurrency(bonusBalance, 2) }}</div>
            </div>
            <div class="btns">
                <div @click="toDeposit">
                    {{ $t("deposit.Deposit") }}
                </div>
                <div @click="toWithdraw">
                    {{ $t("Withdraw.Withdraw") }}
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    data() {
        return {}
    },
    computed: {
        gameBalance() {
            return this.$store.getters.userInfo?.balanceAmtAccount?.useBalance ?? 0
        },
        bonusBalance() {
            // The locked account is shown as the bonus balance; bonusAmtAccount is retired.
            return this.$store.getters.userInfo?.lockAmtAccount?.useBalance ?? 0
        },
        show: {
            get() {
                return this.$store.state.user.isShowBalancePopup
            },
            set(val) {
                this.$store.dispatch('user/setIsShowBalancePopup', val)
            }
        }
    },
    methods: {
        close() {
            this.$store.dispatch('user/setIsShowBalancePopup', false)
        },
        toDeposit() {
            this.close()
            if (this.$route.path === '/wallet' && this.$route.query.type === 'deposit') {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toWithdraw() {
            this.close()
            if (this.$route.path === '/wallet' && this.$route.query.type === 'Withdraw') {
                return
            }
            const params = { type: 'Withdraw' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.van-popup {
    background: transparent;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    overflow: visible;
}

.content {
    padding: .3rem;
    box-sizing: border-box;
    width: 88vw;
    max-width: 5rem;
    background: $bg-popup-color;
    border-radius: .14rem;
    position: relative;
    color: $font-color;
    font-size: .24rem;
    text-align: center;

    .item-balance {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 700;
        font-size: .28rem;
        min-height: .48rem;
        gap: .2rem;
        text-align: left;
        color: $font-color;

        & > div:first-child {
            flex: 1;
            min-width: 0;
        }

        & > div:last-child {
            flex-shrink: 0;
            font-variant-numeric: tabular-nums;
        }

        .item-balance-val1 {
            color: $font-theme-color;
        }

        .item-balance-val3 {
            color: $font-error-color;
        }
    }

    .btns {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: .3rem;
        gap: .16rem;

        &>div {
            height: .64rem;
            width: calc(50% - .08rem);
            display: flex;
            align-items: center;
            justify-content: center;
            color: $font-title-color;
            font-size: .28rem;
            border-radius: .18rem;
            font-weight: bold;
            cursor: pointer;
            background: var(--aurora-lilac);
            border: 1px solid rgba($font-label-color, .18);
            box-shadow: inset 0 1px 0 rgba($font-title-color, .06);

            &:first-child {
                background: var(--aurora-primary-gradient);
                color: var(--aurora-on-primary);
                border-color: $border-home-popup-strong-color;
                box-shadow: $shadow-component-button-color;
            }
        }
    }
}
</style>
